module.exports = __webpack_public_path__ + "static/media/google-logo.cd8d84d4.svg";